import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIconDotsVerticalOutlined = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 32 32" aria-hidden={!title && !titleId} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="M16 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6" /></svg>;
export default SvgIconDotsVerticalOutlined;